import Industries from './Industries';

export default Industries;
